import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { RouteSegment } from '@core/enums/route-segment.enum';

import { ChargerOperationalStatusStoreModelEnum } from '@domain/sites/sites.enums';

import { InfrastructureOverviewSectionComponent } from '@shared/components/infrastructure-overview-section';
import { MovablePanelTitleComponent } from '@shared/components/movable-panel-title';
import { MoveablePanelComponent } from '@shared/components/moveable-panel/moveable-panel.component';
import { PanelLinkComponent } from '@shared/components/panel-link';
import { StatusComponent } from '@shared/components/status/status.component';
import { StatusViewModelEnum } from '@shared/components/status/status.view-model';
import { TranslateChargerStatePipe } from '@shared/pipes/translate-enum-pipes/translate-charger-state.pipe';

import { appChargingStation20Icon } from '@icons/charging-station-20';
import { appFaulted16Icon } from '@icons/faulted-16';

import { ChargersOverviewMovablePanelLoadingSkeletonComponent } from '../chargers-overview-movable-panel-loading-skeleton';
import { ChargersOverviewMovablePanelViewModel } from './chargers-overview-movable-panel.view-model';

@Component({
  selector: 'app-chargers-overview-movable-panel',
  imports: [
    MoveablePanelComponent,
    MovablePanelTitleComponent,
    InfrastructureOverviewSectionComponent,
    StatusComponent,
    SvgIconComponent,
    TranslatePipe,
    TranslateChargerStatePipe,
    RouterLink,
    PanelLinkComponent,
    ChargersOverviewMovablePanelLoadingSkeletonComponent,
  ],
  templateUrl: './chargers-overview-movable-panel.component.html',
  host: { class: 'flex flex-col' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargersOverviewMovablePanelComponent {
  public vm = input<ChargersOverviewMovablePanelViewModel>();
  public isLoading = input<boolean>(false);

  public readonly StatusViewModelEnum = StatusViewModelEnum;
  public readonly ChargerStateStoreModelEnum = ChargerOperationalStatusStoreModelEnum;
  public readonly RouteSegment = RouteSegment;

  constructor() {
    injectRegisterIcons([appChargingStation20Icon, appFaulted16Icon]);
  }
}
